import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Iconify } from 'src/components';
import CompletedBySelector from './CompletedBySelector';

/**
 * AnswerTheCallLive - Component for tracking who completed the call
 * - Shows "Completed by" selector only
 */
const AnswerTheCallLive = ({ formData, onChange, disabled, practiceUsers }) => {
  const theme = useTheme();
  const completedBy = formData.answerTheCallCompletedBy || null;

  const handleCompletedByChange = useCallback((userId) => {
    if (disabled) return;
    onChange('answerTheCallCompletedBy', userId);
  }, [onChange, disabled]);

  return (
    <Box sx={{ width: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
          p: 2,
          borderRadius: '12px',
          border: `1px solid ${theme.palette.divider}`,
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#00B8D914',
              flexShrink: 0,
            }}
          >
            <Iconify
              icon="solar:phone-calling-bold"
              sx={{
                width: 22,
                height: 22,
                color: '#00B8D9',
              }}
            />
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography
              sx={{
                fontSize: '0.875rem',
                fontWeight: 500,
                color: theme.palette.text.secondary,
              }}
            >
              Completed by
            </Typography>
          </Box>
        </Box>

        <CompletedBySelector
          users={practiceUsers}
          selectedUserId={completedBy}
          onChange={handleCompletedByChange}
          disabled={disabled}
        />
      </Box>
    </Box>
  );
};

AnswerTheCallLive.propTypes = {
  formData: PropTypes.object,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  practiceUsers: PropTypes.array,
};

AnswerTheCallLive.defaultProps = {
  formData: {},
  onChange: () => {},
  disabled: false,
  practiceUsers: [],
};

export default AnswerTheCallLive;
